import {
  SET_COURSE_OUTLINE,
  GET_COURSE_OUTLINE,
  RESET_COURSE_OUTLINE,
} from 'legacy/src/constants/types';

const initialState = {
  isLoadingSubjectCourseOutline: false,
};

const courseOutline = (state = initialState, { type, payload, subject }) => {
  switch (type) {
    case GET_COURSE_OUTLINE:
      return {
        ...state,
        isLoadingSubjectCourseOutline: payload.loading,
      };
    case SET_COURSE_OUTLINE:
      return {
        ...state,
        [subject]: payload,
        isLoadingSubjectCourseOutline: false,
      };
    case RESET_COURSE_OUTLINE:
      return {
        isLoadingSubjectCourseOutline: false,
      };
    default:
      return state;
  }
};

export default courseOutline;
